import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'section-header',
  standalone: false,
  templateUrl: './section-header.component.html',
  styleUrl: './section-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionHeaderComponent {

}
